import { AtsLayout } from './AtsLayout';

export interface AtsLayoutWideProps {
  children: React.ReactNode;
}

/**
 * Wide layout variant for pages that need full width and no page scroll.
 * Currently used for: Job Detail page (Kanban board)
 */
export function AtsLayoutWide({ children }: AtsLayoutWideProps) {
  return (
    <AtsLayout maxWidth="full" overflow="hidden">
      {children}
    </AtsLayout>
  );
}
